import { Link } from "react-router-dom";
import classes from "./index.module.scss";
import { v4 as uuid } from "uuid";
import Text from "../../../components/commons/Text";
import { ReactComponent as TagIcon } from "../images/tag.svg";
import { ReactComponent as LocationIcon } from "../images/location.svg";
import { ReactComponent as DateIcon } from "../images/date.svg";
import { ReactComponent as TimeIcon } from "../images/time.svg";

import { getDay } from "../../../helpers/getDate";

export default function Card({ card }) {
  const {
    slug,
    custom_fields: { shortDescription, date, time, location },
    title: { rendered: title },
    _embedded: {
      "wp:term": [, tags],
    },
    _embedded: {
      "wp:term": [categories],
    },
  } = card;

  return (
    <Link to={slug} className={classes.card}>
      {categories && categories.length ? (
        <ul className={classes.card__categories}>
          {categories.map((category) => (
            <li
              className={`${
                category.name === "Webinar"
                  ? classes.dark
                  : category === "Live event"
                  ? classes.green
                  : classes.light
              }`}
              key={uuid()}
            >
              {category.name}
            </li>
          ))}
        </ul>
      ) : null}
      <h3 className={classes.card__title}>{title}</h3>
      {tags && tags.length ? (
        <p className={classes.card__description}>
          <TagIcon />
          {tags.map((tag) => tag.name).join(", ")}
        </p>
      ) : null}
      {location ? (
        <p className={classes.card__description}>
          <LocationIcon />
          {location}
        </p>
      ) : null}
      {date && time ? (
        <div className={classes.card__date}>
          <p className={classes.card__description}>
            <DateIcon />
            {getDay(date, time).date}
          </p>
          <p className={classes.card__description}>
            <TimeIcon />
            {getDay(date, time).time}
          </p>
        </div>
      ) : null}
      {shortDescription ? (
        <Text className={classes.card__text} text={[shortDescription]} />
      ) : null}

      <span className={classes["learn-more"]}>Learn more</span>
    </Link>
  );
}
